module.exports = __webpack_public_path__ + "media/images/icons/outlined/strikethrough-3ff07c433710279f51799cee5dd78756.svg";